export default {
  name: 'langable',
  data: () => ({
    lang: null
  }),
  computed: {
    computed_lang() {
      return this.$store.state.lang
    },
    langs() { return this.$store.state.langs },
  },
  mounted() {
    this.lang = this.computed_lang
  },
  watch: {
    lang: {
      deep: true,
      handler() {
        // this.$store.commit('lang', this.lang)
        this.$i18n.locale = this.lang.value
      }
    }
  }
}